// Payment cell renderer for the milestone table. Surfaces the per-row
// dollar amount plus an optional "· N% of contract" subtitle that
// contextualises the milestone against the contract's total value.
//
// Empty-state rules (see plan §5b for rationale):
// - amount missing or 0 → render em-dash, no subtitle
// - contractValue missing or 0 → render dollar amount only (divide-by-
//   zero guard; covers the "contract.value not yet set" case)
// - both present and >0 → render dollar amount + percentage subtitle

import { formatAud2dp } from "../../../../utils/formatCurrency";

interface PaymentCellProps {
  amount?: number;
  contractValue?: number;
}

export default function PaymentCell({
  amount,
  contractValue,
}: PaymentCellProps) {
  if (typeof amount !== "number" || amount === 0) {
    return <span className="text-slate-400 dark:text-slate-500">—</span>;
  }
  const dollar = formatAud2dp(amount);
  const showPct = typeof contractValue === "number" && contractValue > 0;
  if (!showPct) return <span>{dollar}</span>;
  const pct = Math.round((amount / contractValue) * 100);
  return (
    <div>
      <div>{dollar}</div>
      <div className="text-caption text-slate-500 dark:text-slate-400">
        · {pct}% of contract
      </div>
    </div>
  );
}
